import type { ReactNode } from 'react';

/**
 * Layout de las pantallas de auth (login, MFA, forgot password, etc.) — identidad SureKeep.
 *
 * Look del mock (mockups/_shared): fondo plano slate por token (--muted/40), whitespace y la Card
 * centrada. Sin logo/wordmark: estado pre-auth (sin tenant resuelto).
 */
export function AuthLayout({ children }: { children: ReactNode }) {
    return (
        <div className="flex min-h-screen items-center justify-center bg-muted/40 p-4 text-foreground">
            <div className="flex w-full justify-center">{children}</div>
        </div>
    );
}
